import {Injectable} from '@angular/core';
import {IGetImageService} from '../../../../../@core/services/images/IGetImageService';
import {environment} from '../../../../../environments/environment';

@Injectable({providedIn: 'root'})
export class GetUserAvatarService implements IGetImageService {


    getImageUrl(userId: number | string) {
        if (typeof userId === 'string' && userId.startsWith('data:image')) {
            return userId
        }

        return `${environment.apiUrl}users/${userId}/profileImage`;
    }
}
